module.exports = __webpack_public_path__ + "static/PFB__0002_Battery-d4afd00fa6f56b0528cec14c957c8aa1.png";